import { inject, Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { IPList, OPList } from './global-search.types';
import { AppBaseService } from '../services/http.service';

export interface SearchListItem {
  id: string;
  name: string;
  module: 'IP' | 'OP';
}

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private readonly appBaseService = inject(AppBaseService);

  private readonly opUrl =
    '/ipd-clinical/op/dashboard/list?customerBussinessId=18&userId=45785&specializationIdentifer=&startDate=1776025800000&endDate=1778704140000&gender=null&displayEncounterNumber=null&visitTypeId=&payerTypeId=&appointmentStatusId=&patientNameMpi=&dateOfBirth=0&appointmentModeId=&siteId=5&page=0&size=15&appointmentCatagory=Consult&tokenNumber=';
  private readonly ipUrl =
    '/ipd-clinical/dashboard/list?customerBussinessId=18&admitType=ALL&admitStatus=All%20Patient&patientNameMpi=JINEESH%20JOY&gender=&dateOfBirth=&startDate=1735590600000&endDate=1778272199000&userId=0&physicianId=0&secondaryPhysicianId=&admissionStatus=&pageNo=0&pageSize=15&wardName=&typeOfAdmissionToWard=null&assessmentStatus=null&siteId=5';

  getIPList(): Observable<IPList> {
    return this.appBaseService.getCMSResource(this.ipUrl);
  }

  getOPList(): Observable<OPList> {
    return this.appBaseService.getCMSResource(this.opUrl);
  }

  getList(): Observable<SearchListItem[]> {
    return forkJoin({
      ip: this.getIPList(),
      op: this.getOPList(),
    }).pipe(
      map(({ ip, op }) => {
        console.log('IP List:', ip, 'OP List:', op);
        const ipItems: SearchListItem[] = ip.data.data.map((item) => ({
          id: item.id,
          name: item.patient?.patientName ?? 'NA',
          mrn: item.patient?.externalMPI ?? 'NA',
          patientStatus: {
            code: item.admission?.admitStatus?.identifierCode ?? 'NA',
            label: item.admission?.admitStatus?.name ?? 'NA',
          },
          physician: {
            name: item.admission?.admittingDoctor?.fullName ?? 'NA',
            specialization: item.admission?.specialization?.name ?? 'NA',
          },
          location: item.admission?.currentLocation,
          module: 'IP',
        }));

        const opItems: SearchListItem[] = op.data.data.map((item) => ({
          id: item.id,
          name: item.patientName ?? 'NA',
          mrn: item?.externalMPI ?? 'NA',
          patientStatus: {
            code: item.admitStatus?.identifierCode ?? 'NA',
            label: item.admitStatus?.name ?? 'NA',
          },
          physician: {
            name: item?.physicianName ?? 'NA',
            specialization: item.specialization?.name ?? 'NA',
          },
          location: 'NA',
          module: 'OP',
        }));

        return [...ipItems, ...opItems];
      }),
    );
  }
}
